import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { PublicRoute } from "./routes";

// import Login from 'views/Login/Login'
// import ForgotPassword from 'views/Login/ForgotPassword'
// import NewPassword from 'views/Login/NewPassword'

// Views
import ShoveBerryHome from "views/ShoveBerry/ShoveBerryHome";
import ShoveBerryLevel from "views/ShoveBerry/ShoveBerryLevel";

import AppRouter from "router/appRouter";

function RootRouter() {
  return (
    <Switch>
      {/* Add those routes here which do not need any layout such as login etc. */}
      {/* <PublicRoute exact path="/login" component={Login} />
      <PublicRoute exact path="/reset-password" component={ForgotPassword} />
      <PublicRoute exact path="/new-password" component={NewPassword} /> */}
      <PublicRoute exact path="/" component={ShoveBerryHome} />
      <PublicRoute exact path="/shoveberry/level" component={ShoveBerryLevel} />
      <AppRouter />
    </Switch>
  );
}

export default RootRouter;
